__turbopack_context__.v({
  "link": "styles-module__mSJvka__link",
  "selected-link": "styles-module__mSJvka__selected-link",
});
